export const NOT_SCRIPTED = "NOT_SCRIPTED";
export const SCRIPTED = "SCRIPTED";
